import React from "react";
import { HomeIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Folder } from "../types";

interface BreadcrumbsProps {
  folderPath: Folder[];
  navigateToRoot: () => void;
  onBreadcrumbClick: (folder: Folder, index: number) => void;
}

const VideoBreadcrumbs: React.FC<BreadcrumbsProps> = ({
  folderPath,
  navigateToRoot,
  onBreadcrumbClick,
}) => {
  return (
    <div className="mb-2 lg:mb-4">
      <nav className="flex overflow-hidden" aria-label="Breadcrumb">
        <ol className="flex items-center space-x-1 lg:space-x-2 min-w-0">
          <li>
            <button
              onClick={navigateToRoot}
              className="flex items-center px-2 lg:px-3 py-1 lg:py-2 text-gray-500 hover:text-gray-700 hover:bg-white rounded-lg transition-all duration-200 text-sm"
            >
              <HomeIcon className="h-4 w-4 lg:h-5 lg:w-5 mr-1 lg:mr-2" />
              <span className="hidden sm:inline text-sm font-medium">
                ໜ້າຫຼັກ
              </span>
            </button>
          </li>
          {folderPath.map((folder, index) => (
            <li key={`breadcrumb-${folder.id}-${index}`}>
              <div className="flex items-center">
                <ChevronRightIcon className="h-3 w-3 lg:h-4 lg:w-4 text-gray-400 mx-1 lg:mx-2" />
                <button
                  onClick={() => onBreadcrumbClick(folder, index)}
                  className="px-2 lg:px-3 py-1 lg:py-2 text-sm font-medium text-gray-500 hover:text-gray-700 hover:bg-white rounded-lg transition-all duration-200 max-w-20 sm:max-w-32 truncate"
                  title={folder.name}
                >
                  {folder.name}
                </button>
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default VideoBreadcrumbs;
